import React, { Component } from "react";
import { PieChart } from "react-minimal-pie-chart";

export default class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: undefined,
      hovered: undefined,
    };
  }

  render() {
    const lineWidth = 60;

    const data = this.props.data.filter(entry => entry.value > 0 ).map((entry, i) => {
      if (this.state.hovered === i) {
        return {
          ...entry,
          color: "#FF9000",
        };
      }
      return entry;
    });

    return (
      <PieChart
        style={{
          fontSize: "0.22rem",
        }}
        data={data}
        radius={PieChart.defaultProps.radius - 6}
        lineWidth={60}
        segmentsStyle={{ transition: "stroke .3s", cursor: "pointer" }}
        segmentsShift={(index) => (index === this.state.selected ? 6 : 1)}
        animate
        label={({ dataEntry }) =>
          dataEntry.title.substring(0, 20) + " (" + Math.round(dataEntry.value) + ")"
        }
        labelPosition={100 - lineWidth / 2}
        labelStyle={{
          fill: "#fff",
          textShadow: "2px 2px 2px black",
          opacity: 0.75,
          pointerEvents: "none",
        }}
        onClick={(_, index) => {
          this.setState({
            selected: index === this.state.selected ? undefined : index,
          });

          if (index === this.state.selected) 
            this.props.onSelect(undefined)
          else
            this.props.onSelect(data[index].title)
        }}
        onMouseOver={(_, index) => {
          this.setState({ hovered: index });
        }}
        onMouseOut={() => {
          this.setState({ hovered: undefined });
        }}
      />
    );
  }
}
